import React, { useState } from "react";

import ReactLogo from "../../../assets/Svgs/reactjs.svg";
import NextLogo from "../../../assets/Svgs/nextjs.svg";
import JsLogo from "../../../assets/Svgs/javascript.svg";
import PwaLogo from "../../../assets/Svgs/pwa.svg";
import LaravelLogo from "../../../assets/Svgs/laravel.svg";
import Bubble from "../../../assets/Svgs/bubble-orange.svg";

import styled from "./index.module.css";

const Knowledge = (props) => {
  const ABILITIES = [
    {
      title: "React Js",
      text:
        "React is a JavaScript library for building user interfaces. React is my fav library for make project's front-end. that's exteraordinary.",
      percent: 75,
      logo: ReactLogo,
    },
    {
      title: "Next Js",
      text:
        "Next.js gives you the best developer experience with all the features you need for production: hybrid static & server rendering, TypeScript support, smart bundling, route pre-fetching, and more. No config needed.",
      percent: 98,
      logo: NextLogo,
    },
    {
      title: "Javascript",
      text:
        "Everyone knows the amazing features of JavaScript in programming. I like it too more that you expected.",
      percent: 80,
      logo: JsLogo,
    },
    {
      title: "PWA",
      text:
        "Whether you already have a website or you're just getting started, you can make pwa for your site, pwa help you to make app for every os. programming web app is big section of whole mobile apps future.",
      percent: 70,
      logo: PwaLogo,
    },
    {
      title: "Laravel",
      text:
        "Laravel is a web application framework with expressive, elegant syntax. We’ve already laid the foundation — freeing you to create without sweating the small things.",
      percent: 90,
      logo: LaravelLogo,
    },
  ];
  const [activeAbility, setActiveAbility] = useState(2);

  const changeAbility = (id) => {
    knowledgeAnimationClose(id);
    knowledgeAnimationSlider(id);
    setTimeout(() => {
      setActiveAbility(id);
    }, 250);
    setTimeout(() => {
      knowledgeAnimationOpen(id);
    }, 500);
  };
  const knowledgeAnimationClose = (id) => {
    var logo = document.getElementById("ability_logo");
    var title = document.getElementById("ability_title");
    var text = document.getElementById("ability_text");
    var percent = document.getElementById("ability_percent");
    var percent_mobile = document.getElementById("ability_percent_mobile");
    logo.style.transition = "0.25s";
    title.style.transition = "0.25s";
    text.style.transition = "0.25s";
    percent.style.transition = "0.25s";
    percent_mobile.style.transition = "0.25s";
    logo.style.transform = "rotate(100deg)";
    logo.style.opacity = 0;
    title.style.transform = "translate(90%, 0)";
    title.style.opacity = 0;
    text.style.transform = "translate(0, 90%)";
    text.style.opacity = 0;
  };
  const knowledgeAnimationOpen = (id) => {
    var logo = document.getElementById("ability_logo");
    var title = document.getElementById("ability_title");
    var text = document.getElementById("ability_text");
    var percent = document.getElementById("ability_percent");
    var percent_mobile = document.getElementById("ability_percent_mobile");
    logo.style.transition = "0.25s";
    title.style.transition = "0.25s";
    text.style.transition = "0.25s";
    percent.style.transition = "0.25s";
    percent_mobile.style.transition = "0.25s";
    logo.style.transform = "rotate(0deg)";
    logo.style.opacity = 1;
    title.style.transform = "translate(0, 0)";
    title.style.opacity = 1;
    text.style.transform = "translate(0, 0)";
    text.style.opacity = 1;
  };
  const knowledgeAnimationSlider = (id) => {
    var s0 = document.getElementById("knowledge_slider_0");
    var s1 = document.getElementById("knowledge_slider_1");
    var s2 = document.getElementById("knowledge_slider_2");
    var s3 = document.getElementById("knowledge_slider_3");
    var s4 = document.getElementById("knowledge_slider_4");
    s0.style.transition = "0.25s";
    s1.style.transition = "0.25s";
    s2.style.transition = "0.25s";
    s3.style.transition = "0.25s";
    s4.style.transition = "0.25s";
  };

  return (
    <div className={styled.knowledge}>
      <div className={styled.knowledge_box}>
        <div className={styled.kb_head_box}>
          <img
            src={Bubble}
            alt="w-e"
            className={[styled.kb_hb_icon, styled.disable_highlight].join(" ")}
          />
          <p
            className={[styled.kb_hb_title, styled.disable_highlight].join(" ")}
          >
            Knowledge
          </p>
        </div>

        <div className={styled.kb_body_box}>
          <div className={styled.kb_bb_slider_box}>
            <div className={styled.kb_bb_sb_slider}>
              <div className={styled.kb_bb_sb_s_slider_piece}>
                <div
                  id="knowledge_slider_0"
                  className={[
                    styled.kb_bb_sb_s_sp_piece,
                    styled.disable_highlight,
                    activeAbility === 0
                      ? styled.kb_bb_sb_s_sp_piece_active
                      : "",
                  ].join(" ")}
                  onClick={() => changeAbility(0)}
                ></div>
                <div
                  id="knowledge_slider_1"
                  className={[
                    styled.kb_bb_sb_s_sp_piece,
                    styled.disable_highlight,
                    activeAbility === 1
                      ? styled.kb_bb_sb_s_sp_piece_active
                      : "",
                  ].join(" ")}
                  onClick={() => changeAbility(1)}
                ></div>
                <div
                  id="knowledge_slider_2"
                  className={[
                    styled.kb_bb_sb_s_sp_piece,
                    styled.disable_highlight,
                    activeAbility === 2
                      ? styled.kb_bb_sb_s_sp_piece_active
                      : "",
                  ].join(" ")}
                  onClick={() => changeAbility(2)}
                ></div>
                <div
                  id="knowledge_slider_3"
                  className={[
                    styled.kb_bb_sb_s_sp_piece,
                    styled.disable_highlight,
                    activeAbility === 3
                      ? styled.kb_bb_sb_s_sp_piece_active
                      : "",
                  ].join(" ")}
                  onClick={() => changeAbility(3)}
                ></div>
                <div
                  id="knowledge_slider_4"
                  className={[
                    styled.kb_bb_sb_s_sp_piece,
                    styled.disable_highlight,
                    activeAbility === 4
                      ? styled.kb_bb_sb_s_sp_piece_active
                      : "",
                  ].join(" ")}
                  onClick={() => changeAbility(4)}
                ></div>
              </div>
              <div className={styled.kb_bb_sb_s_text_box}>
                <img
                  id="ability_logo"
                  src={ABILITIES[activeAbility].logo}
                  alt="icon"
                  className={[
                    styled.kb_bb_sb_s_tb_logo,
                    styled.disable_highlight,
                  ].join(" ")}
                />
                <p
                  id="ability_title"
                  className={[
                    styled.kb_bb_sb_s_tb_title,
                    styled.disable_highlight,
                  ].join(" ")}
                >
                  {ABILITIES[activeAbility].title}
                </p>
                <p
                  id="ability_text"
                  className={[
                    styled.kb_bb_sb_s_tb_text,
                    styled.disable_highlight,
                  ].join(" ")}
                >
                  {ABILITIES[activeAbility].text}
                </p>
                {/* <div className={styled.kb_bb_sb_s_tb_detail_box}>
                  <button className={styled.kb_bb_sb_s_tb_db_bb_button}>
                    More about {ABILITIES[activeAbility].title}
                  </button>
                </div> */}
              </div>
              <div className={styled.kb_bb_sb_s_tb_ability_box}>
                <div className={styled.kb_bb_sb_s_tb_ab_circle_box}>
                  <svg height="180px" width="100%">
                    <circle
                      cx="50%"
                      cy="50%"
                      r="80"
                      fill="none"
                      strokeWidth="2"
                      stroke="#e1e1e1"
                      strokeLinecap="round"
                      strokeDasharray="0"
                      strokeDashoffset="0"
                    ></circle>
                    <circle
                      id="ability_percent"
                      cx="50%"
                      cy="50%"
                      r="80"
                      fill="none"
                      strokeWidth="5"
                      stroke="#ff4800"
                      strokeLinecap="round"
                      strokeDasharray="500"
                      strokeDashoffset={
                        500 - (500 * ABILITIES[activeAbility].percent) / 100
                      }
                    ></circle>
                  </svg>
                  <div className={styled.kb_bb_sb_s_tb_ab_cb_text_box}>
                    <p
                      className={[
                        styled.kb_bb_sb_s_tb_ab_cb_percent,
                        styled.disable_highlight,
                      ].join(" ")}
                    >
                      {ABILITIES[activeAbility].percent}%
                    </p>
                  </div>
                </div>
              </div>

              <div className={styled.kb_bb_sb_s_tb_ab_circle_box_mobile_device}>
                <svg height="60px" width="100%">
                  <circle
                    cx="50%"
                    cy="50%"
                    r="28"
                    fill="none"
                    strokeWidth="1"
                    stroke="#e1e1e1"
                    strokeLinecap="round"
                    strokeDasharray="0"
                    strokeDashoffset="0"
                  ></circle>
                  <circle
                    id="ability_percent_mobile"
                    cx="50%"
                    cy="50%"
                    r="28"
                    fill="none"
                    strokeWidth="3"
                    stroke="#ff4800"
                    strokeLinecap="round"
                    strokeDasharray="175"
                    strokeDashoffset={
                      175 - (175 * ABILITIES[activeAbility].percent) / 100
                    }
                  ></circle>
                </svg>
                <div className={styled.kb_bb_sb_s_tb_ab_cb_text_box}>
                  <p
                    className={[
                      styled.kb_bb_sb_s_tb_ab_cb_percent_mobile_device,
                      styled.disable_highlight,
                    ].join(" ")}
                  >
                    {ABILITIES[activeAbility].percent}%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Knowledge;
